import React from "react";
import { Link } from "react-router-dom";

const BlogList = ({ blogs, title }) => {
  return (
    <div className="blog-list space-y-8">
      <h2 className="text-2xl font-bold text-slate-800 mb-6 flex items-center gap-3">
        <span className="w-1.5 h-8 bg-gradient-to-b from-primary to-rose-600 rounded-full block"></span>
        {title}
      </h2>
      <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-1"> 
        {blogs.map((blog) => (
          <div className="blog-preview group h-full" key={blog.id}>
            <Link to={`/blogs/${blog.id}`} className="block bg-white p-6 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-primary/20 transform hover:-translate-y-1 h-full flex flex-col justify-between relative overflow-hidden">
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-primary/5 to-transparent rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110"></div>
              
              <div>
                  <h3 className="text-xl font-bold text-slate-800 group-hover:text-primary transition-colors mb-2">{blog.title}</h3>
                  <p className="text-sm text-slate-500 font-medium mb-3">Written by <span className="text-primary">{blog.author}</span></p>
                  <p className="text-slate-500 mb-4 line-clamp-2 text-sm leading-relaxed">
                      {blog.body}
                  </p>
              </div>
              
              <div className="pt-4 border-t border-slate-50 flex items-center justify-between text-xs font-medium text-slate-400">
                  <span className="flex items-center gap-1">
                      <span className="text-primary bg-primary/10 px-2 py-1 rounded-full">{blog.author}</span>
                  </span>
                  <span>{blog.date ? new Date(blog.date).toLocaleDateString() : 'Read more →'}</span>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BlogList